import { render, staticRenderFns } from "./EditResource.vue?vue&type=template&id=8111b7b0&scoped=true&"
import script from "./EditResource.vue?vue&type=script&lang=js&"
export * from "./EditResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8111b7b0",
  null
  
)

export default component.exports